var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M10 3H14V14H10V3M10 21V17H14V21H10Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }